module.exports = __webpack_public_path__ + "img/foot-2.69c27106.png";